<template>
  <Card>
    <template v-slot:content>
      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <Skeleton v-if="loading" height="30px" />
          <h5 v-else>Bovinos por lote/piquete na fazenda</h5>
        </div>
        <div class="p-col-12 p-md-6">
          <Skeleton v-if="loading" height="30px" />
          <Dropdown
            v-else
            v-model="query.farmId"
            :options="farms"
            @change="getData()"
            optionLabel="name"
            optionValue="id"
            style="width: 100%"
          />
        </div>
        <div class="p-col-12">
          <Skeleton v-if="loading" height="235px" />
          <Chart
            v-else
            ref="chart"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            :width="200"
            :height="80"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Chart from 'primevue/chart';
import { ReportApi } from '../../../services/api';

const types = {
  1: { color: '#000', name: 'Touro' },
  2: { color: '#9A7A54', name: 'Boi' },
  3: { color: '#FFE600', name: 'Vaca' },
  4: { color: '#0085FF', name: 'Bezerro' },
  5: { color: '#FF0000', name: 'Bezerra' },
  6: { color: '#FFE600', name: 'Vaca' },
  7: { color: '#FFE600', name: 'Vaca' },
  8: { color: '#FFE600', name: 'Vaca' },
};

export default {
  components: { Chart },
  data() {
    return {
      chartOptions: {
        plugins: {
          legend: {
            display: false,
          },
        },
      },
      chartData: { labels: [], datasets: [] },
      query: { farmId: null },
      farms: [],
      loading: true,
    };
  },
  watch: {
    async farms(newValue, oldValue) {
      if (!oldValue.length && newValue.length) {
        this.query.farmId = this.farms?.[0]?.id || null;
        await this.getData();
      }
    },
  },
  methods: {
    async setFarms(farms) {
      if (!farms.length) {
        this.loading = false;
      }
      this.farms = farms;
    },
    async getData() {
      try {
        const data = await ReportApi.getBovinesByLot(this.query);
        const labels = data.lotNames.map((label, index) => {
          const count = data.results.reduce(
            (final, next) => final + next.items[index].count,
            0
          );
          return `${label} (${count})`;
        });
        this.chartData = {
          labels,
          datasets: data.results.map((result) => {
            return {
              label: types[result.typeId].name,
              backgroundColor: types[result.typeId].color,
              data: result.items.map((item) => item.count),
            };
          }),
        };
        if (this.$refs.chart) {
          this.$refs.chart.reinit();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0;
}
</style>
